import { AppConfigSchema, AppEnv, AppPlatform } from 'src/app/app.config';

export const environment: AppConfigSchema = {
  env: AppEnv.prod,
  platform: AppPlatform.alertsense,
  production: true,
};